"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8730],{

/***/ 13390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shared_Footer; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(37337);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Link/Link.mjs
var Link = __webpack_require__(47208);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Box/Box.mjs
var Box = __webpack_require__(8013);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Flex/Flex.mjs
var Flex = __webpack_require__(93298);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Text/Text.mjs
var Text = __webpack_require__(4796);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/colors.mjs
var colors = __webpack_require__(81762);
// EXTERNAL MODULE: ./src/helpers/observability.ts + 56 modules
var observability = __webpack_require__(77997);
;// CONCATENATED MODULE: ./src/components/RegularContainer.tsx

var flexStyle = function(props) {
    if (props.flex) {
        return "\n    display: flex;\n\n    @media (max-width: 767px) {\n      display: block;\n      max-width: 100%;\n    }\n    ";
    }
    return "";
};
/* harmony default export */ var RegularContainer = (/*#__PURE__*/(0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e172dnmf0"
})("margin-right:auto;margin-left:auto;max-width:960px;position:relative;::after{content:'';display:block;clear:both;}@media (max-width:1199px){max-width:720px;}@media (max-width:767px){max-width:90%;}", flexStyle, ";"));

;// CONCATENATED MODULE: ./src/components/shared/Footer2022/AccessibilityText.tsx


var AccessibilityText = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            "Opendoor Labs Inc. is dedicated to improving the accessibility of its Website and we view accessibility as a continually ongoing effort. Please contact us at",
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                fontWeight: "semibold",
                href: "mailto:support@opendoor.com",
                "aria-label": "",
                analyticsName: "cosmos-contact-opendoor-email",
                children: "support@opendoor.com"
            }),
            " ",
            "with any support needs, feedback or suggestions."
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/shared/Footer.tsx









var FooterCol = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ewly3tz0"
})("width:25%;@media (max-width:767px){float:left;width:45%;margin-right:5%;text-align:left;}");
var FooterColA = function(param) {
    var label = param.label, href = param.href, style = param.style, children = param.children;
    var trackEvent = (0,observability/* useObservability */.C3)().trackEvent;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
        color: "neutrals90",
        // TODO: add analyticsName and remove onClick
        analyticsName: "",
        "aria-label": null,
        href: href,
        style: style,
        onClick: function() {
            return(// TODO: remove categoryOverride
            // observability is initialized with 'cosmos' as the category for all events
            trackEvent("cta-click", label, undefined, {
                categoryOverride: "homepage"
            }));
        },
        children: children
    });
};
var FooterColUL = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", {
    target: "ewly3tz1"
})("padding:0;margin:10px 0 30px 0;list-style:none;");
var FooterColLI = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", {
    target: "ewly3tz2"
})("padding:0;margin:10px 0;");
var hiddenXSDown = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("@media (max-width:767px){display:none !important;}");
var leftSpaceXs = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("@media (max-width:767px){margin-left:25px;}");
var H6 = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h6", {
    target: "ewly3tz3"
})("text-transform:uppercase;margin:20px 0;font-size:14px;color:", colors/* default.neutrals100 */.ZP.neutrals100, ";");
var SocialIcons = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ewly3tz4"
})("flex:1;padding:0 0 50px 0;text-align:center;@media (max-width:767px){margin:15px 0;padding:30px 0;border-top:1px solid #dedede;border-bottom:1px solid #dedede;}");
var SocialIconA = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "ewly3tz5"
})("display:inline-block;margin:0 10px;");
var FooterSection = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("footer", {
    target: "ewly3tz6"
})("padding:60px 0;@media (max-width:767px){padding:30px;padding-bottom:120px;}");
var FairHousing = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("img", {
    target: "ewly3tz7"
})("height:45px;@media (max-width:767px){margin-top:20px;height:35px;float:none;}");
var LegalP = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "ewly3tz8"
})("font-size:12px;color:", colors/* default.neutrals90 */.ZP.neutrals90, ";margin:12px 0;a{font-size:12px;text-decoration:underline;margin:12px 0;}");
var copyRow = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", colors/* default.neutrals90 */.ZP.neutrals90, ";font-size:14px;align-items:center;justify-content:center;");
var Footer = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterSection, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RegularContainer, {
                style: {
                    display: "flex",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterCol, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H6, {
                                children: "Sell your home"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterColUL, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "sell-your-home-request-offer",
                                            href: "https://www.opendoor.com/",
                                            children: "Request an offer"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "sell-your-home-reviews",
                                            href: "https://www.opendoor.com/reviews",
                                            children: "Reviews"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "sell-your-home-stories",
                                            href: "https://www.opendoor.com/w/stories",
                                            children: "Stories"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H6, {
                                children: "Buy a home"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColUL, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                        label: "buy-a-home-buy",
                                        href: "https://www.opendoor.com/w/homes",
                                        children: "Buy"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H6, {
                                children: "Partners"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterColUL, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "partners-vendors",
                                            href: "https://www.opendoor.com/w/vendor-partnerships",
                                            children: "Vendors"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "partners-builder",
                                            href: "https://www.opendoor.com/w/partner/builder",
                                            children: "Builder"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterCol, {
                        css: hiddenXSDown,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H6, {
                                children: "Buy and sell"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColUL, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                        label: "trade-in-builder",
                                        href: "https://www.opendoor.com/w/builder",
                                        children: "Builder trade-up"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H6, {
                                children: "Agents"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterColUL, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "agents-make-offer",
                                            href: "https://www.opendoor.com/w/agents#alp-buy--form",
                                            children: "Make an offer"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "agents-request-offer",
                                            href: "https://www.opendoor.com/w/agents",
                                            children: "Request an offer"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H6, {
                                children: "Resources"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterColUL, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "resources-blog",
                                            href: "https://www.opendoor.com/w/blog",
                                            children: "Blog"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "resources-guides",
                                            href: "https://www.opendoor.com/w/resources",
                                            children: "Guides"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "article-briefs",
                                            href: "https://www.opendoor.com/articles/topic/briefs",
                                            children: "Briefs"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "resources-help-center",
                                            href: "https://help.opendoor.com",
                                            children: "Help Center"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterCol, {
                        css: leftSpaceXs,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H6, {
                                children: "About"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterColUL, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "about-company",
                                            href: "https://www.opendoor.com/w/about",
                                            children: "Company"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "about-career",
                                            href: "https://www.opendoor.com/jobs",
                                            children: "Careers"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "about-press",
                                            href: "https://www.opendoor.com/press",
                                            children: "Press"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "about-contact",
                                            href: "https://www.opendoor.com/w/contact-us",
                                            children: "Contact"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "about-investors",
                                            href: "https://investor.opendoor.com/",
                                            children: "Investors"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H6, {
                                children: "Terms & privacy"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterColUL, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "terms-trust-safety",
                                            href: "https://www.opendoor.com/w/safety",
                                            children: "Trust & Safety"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "terms-tos",
                                            href: "https://www.opendoor.com/w/terms",
                                            children: "Terms of Service"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "terms-privacy",
                                            href: "https://www.opendoor.com/w/privacy",
                                            children: "Privacy Policy"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "terms-privacy",
                                            href: "https://www.opendoor.com/w/privacy#ccpa",
                                            children: "Notice at Collection"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColLI, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                            label: "terms-do-not-sell",
                                            href: "https://opendoor-privacy.relyance.ai/",
                                            children: "Do Not Sell My Info"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterCol, {
                        css: hiddenXSDown,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H6, {
                                children: "Download App"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                label: "app-download-android",
                                href: "https://play.google.com/store/apps/details?id=com.opendoor.buyerapp&hl=en",
                                style: {
                                    marginBottom: "10px",
                                    display: "block"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                    src: "https://images.opendoor.com/source/s3/imgdrop-production/3a52f003f27742f3b4384a3168352335.png?preset=square-2048",
                                    alt: "Play store button",
                                    width: 140,
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterColA, {
                                label: "app-download-ios",
                                href: "https://itunes.apple.com/us/app/opendoor-homes-all-day-open/id1143708068?mt=8",
                                style: {
                                    marginBottom: "10px",
                                    display: "block"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                    src: "https://images.opendoor.com/source/s3/imgdrop-production/03f8e282af254a80ac28358e640319ab.svg?preset=square-2048",
                                    alt: "App store button",
                                    width: 140,
                                    loading: "lazy"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RegularContainer, {
                flex: true,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SocialIcons, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialIconA, {
                                href: "https://www.facebook.com/OpendoorHQ",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                    src: "https://images.opendoor.com/source/s3/imgdrop-production/1ac79b6da72048e5ac4e3770a67d9f51.svg?preset=square-2048",
                                    alt: "Facebook",
                                    width: "25px",
                                    height: "25px",
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialIconA, {
                                href: "https://twitter.com/Opendoor",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                    src: "https://images.opendoor.com/source/s3/imgdrop-production/f2641428da574ecf908264f2ab31a032.svg?preset=square-2048",
                                    alt: "Twitter",
                                    width: "25px",
                                    height: "25px",
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialIconA, {
                                href: "https://www.linkedin.com/company/opendoor-com/",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                    src: "https://images.opendoor.com/source/s3/imgdrop-production/eb24a868176f4dc182c1f3de199481e7.svg?preset=square-2048",
                                    alt: "Linkedin",
                                    width: "25px",
                                    height: "25px",
                                    loading: "lazy"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                        href: "https://www.bbb.org/us/az/tempe/profile/real-estate-services/opendoor-1126-1000060421/#sealclick",
                        target: "_blank",
                        rel: "nofollow noopener noreferrer",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                            src: "https://seal-central-northern-western-arizona.bbb.org/seals/blue-seal-200-42-bbb-1000060421.png",
                            alt: "Opendoor BBB Business Review",
                            style: {
                                display: "block",
                                margin: "auto"
                            },
                            loading: "lazy",
                            width: "200px",
                            height: "50px"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RegularContainer, {
                css: copyRow,
                style: {
                    color: colors/* default.neutrals90 */.ZP.neutrals90,
                    fontSize: "14px",
                    display: "flex"
                },
                children: [
                    "\xa9 ",
                    new Date().getFullYear(),
                    " Opendoor",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-left:auto;"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FairHousing, {
                            alt: "Equal Opportunity Housing Logo",
                            src: "https://images.opendoor.com/source/s3/imgdrop-production/2cfd25967a794adabcc97873553da5ab.png?preset=square-2048",
                            loading: "lazy",
                            width: "50px",
                            height: "50px"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RegularContainer, {
                style: {
                    marginTop: "20px"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        mb: 8,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LegalP, {
                            children: [
                                "Learn more about the",
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    href: "https://www.opendoor.com/w/terms#brokerages",
                                    children: "Opendoor Brokerages"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                        flexDirection: "column",
                        mb: 8,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                "aria-label": null,
                                analyticsName: "",
                                fontSize: "s00",
                                variant: "inline-primary",
                                href: "https://www.opendoor.com/w/contact-us",
                                children: "Contact Opendoor Brokerage LLC and Opendoor Brokerage Inc"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, {
                                fontSize: "s00",
                                color: "neutrals90",
                                my: 3,
                                children: [
                                    "Opendoor Brokerage LLC and Opendoor Brokerage Inc. hold real estate brokerage",
                                    " ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        variant: "inline-primary",
                                        "aria-label": null,
                                        analyticsName: "",
                                        fontSize: "s00",
                                        href: "https://www.opendoor.com/brokerages",
                                        children: "licenses"
                                    }),
                                    " ",
                                    "in multiple states."
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                                display: "inline-flex",
                                gap: "2",
                                ml: "9",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                    fontSize: "s00",
                                    color: "neutrals90",
                                    my: 3,
                                    children: "California: Opendoor Brokerage Inc. California DRE# 02061130"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                                display: "inline-flex",
                                gap: "2",
                                ml: "9",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                        fontSize: "s00",
                                        color: "neutrals90",
                                        children: "New York:"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        "aria-label": null,
                                        analyticsName: "",
                                        variant: "inline-primary",
                                        fontSize: "s00",
                                        href: "https://s3.amazonaws.com/odfil.es/static/documents/Dan+NY+Notarized+Doc.pdf",
                                        children: "\xa7 442-H New York Standard Operating Procedures"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        "aria-label": null,
                                        analyticsName: "",
                                        variant: "inline-primary",
                                        fontSize: "s00",
                                        href: "https://s3.amazonaws.com/odfil.es/static/documents/fair-housing-notice.pdf",
                                        children: "\xa7 New York Fair Housing Notice"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                                display: "inline-flex",
                                gap: "2",
                                ml: "9",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                        fontSize: "s00",
                                        color: "neutrals90",
                                        children: "Texas: TREC:"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: "https://buy.opendoor.com/legal/texas/trec/iabs.pdf",
                                        variant: "inline-primary",
                                        fontSize: "s00",
                                        "aria-label": null,
                                        analyticsName: "",
                                        rel: "nofollow",
                                        children: "Information about Brokerage Services"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: "https://www.trec.texas.gov/forms/consumer-protection-notice",
                                        "aria-label": null,
                                        analyticsName: "",
                                        fontSize: "s00",
                                        variant: "inline-primary",
                                        rel: "nofollow",
                                        children: "Consumer Protection Notice"
                                    })
                                ]
                            })
                        ]
                    }),
                    props.addLegaleseText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LegalP, {
                        children: props.addLegaleseText
                    }),
                    props.addLegaleseContent && props.addLegaleseContent,
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LegalP, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccessibilityText, {})
                    }),
                    !props.hideLegalese && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LegalP, {
                                children: "Offer eligibility and purchase price vary. Featured customers may have been compensated for their time. Their opinions and views are solely their own."
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {})
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var shared_Footer = (Footer);


/***/ }),

/***/ 92013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37337);
/* harmony import */ var _opendoor_auth_fe__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95674);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47208);
/* harmony import */ var _opendoor_bricks_core_Box__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8013);
/* harmony import */ var _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81762);
/* harmony import */ var _helpers_observability__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77997);
/* harmony import */ var _account_AccountMenu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26861);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35480);
/* harmony import */ var _EiChevronDownIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87098);
/* harmony import */ var _MenuPanel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37197);












var IconWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6jtd0o0"
})("display:inline-block;width:1em;height:1em;margin-bottom:0.2em;");
var Left = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6jtd0o1"
})("display:flex;flex:1;");
var MenuButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("button", {
    target: "e6jtd0o2"
})("border:0;height:27px;width:27px;margin-right:15px;cursor:pointer;float:left;background:transparent\n    url('https://images.opendoor.com/source/s3/imgdrop-production/06fcecd57df4411b9f7448f24fbff233.svg?preset=square-2048')\n    center no-repeat;padding:0;");
var Middle = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6jtd0o3"
})("@media (max-width:767px){display:none;}");
var Nav = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6jtd0o4"
})("padding-left:0;margin-bottom:0;list-style:none;:before,:after{display:table;content:' ';}:after{clear:both;}");
var NavUL = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("ul", {
    target: "e6jtd0o5"
})("display:inline-block;margin:0;list-style:none;padding:0;");
var NavLI = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("li", {
    target: "e6jtd0o6"
})("display:inline-block;margin:0 10px;");
var activeNavLinkStyle = function(props) {
    if (props.active) {
        return "color: ".concat(_opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_8__/* ["default"].brand50 */ .ZP.brand50, ";");
    }
    return "";
};
var NavLIA = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("a", {
    target: "e6jtd0o7"
})("color:#525975;", activeNavLinkStyle, ";");
var Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("header", {
    target: "e6jtd0o8"
})("background:#ffffff;position:fixed;top:0;left:0;z-index:3;width:100%;box-shadow:0px 3px 40px rgba(68,89,109,0.1);");
var Container = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6jtd0o9"
})("display:flex;padding:15px;justify-content:space-between;");
var Right = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6jtd0o10"
})("flex:1;text-align:right;");
var NavLink = function(props) {
    var trackEvent = (0,_helpers_observability__WEBPACK_IMPORTED_MODULE_3__/* .useObservability */ .C3)().trackEvent;
    var onClickFn = function() {
        // TODO: remove categoryOverride
        // observability is initialized with 'cosmos' as the category for all events
        trackEvent("cta-click", props.elementName, undefined, {
            categoryOverride: "homepage"
        });
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(NavLIA, {
        onClick: onClickFn,
        href: props.href,
        active: props.active,
        "aria-current": props.active,
        children: props.children
    });
};
var SkipLinkContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("button", {
    target: "e6jtd0o11"
})({
    alignItems: "center",
    backgroundColor: _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_8__/* ["default"].neutrals0 */ .ZP.neutrals0,
    border: 0,
    bottom: 0,
    color: _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_8__/* ["default"].brand50 */ .ZP.brand50,
    display: "flex",
    justifyContent: "center",
    left: 0,
    outline: 0,
    position: "absolute",
    top: 0,
    transform: "translateX(-100%)",
    width: "100%",
    zIndex: 1,
    "&:focus": {
        textDecoration: "underline",
        transform: "translateX(0)"
    }
});
var SkipLink = function(_props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(SkipLinkContainer, {
        onClick: function() {
            // there should only be 1 main on any page and it should wrap the main content
            var mainElem = document.querySelector("main");
            mainElem && mainElem.focus();
        },
        children: "Skip to main content"
    });
};
var redirectToLogin = function() {
    document.location.href = "".concat(_globals__WEBPACK_IMPORTED_MODULE_5__/* .COSMOS_URL */ .EQ, "/login?redirectTo=").concat(encodeURIComponent(window.location.pathname));
};
var Header = function(props) {
    var _activeNav = props.activeNav, activeNav = _activeNav === void 0 ? "sell" : _activeNav, extraNavLinks = props.extraNavLinks, hideHeaderNavLinks = props.hideHeaderNavLinks, _isMenuOpen = props.isMenuOpen, isMenuOpen = _isMenuOpen === void 0 ? false : _isMenuOpen, _navMenuButtonId = props.navMenuButtonId, navMenuButtonId = _navMenuButtonId === void 0 ? _MenuPanel__WEBPACK_IMPORTED_MODULE_7__/* .DEFAULT_NAV_MENU_BUTTON_ID */ .Q7 : _navMenuButtonId, _navMenuId = props.navMenuId, navMenuId = _navMenuId === void 0 ? _MenuPanel__WEBPACK_IMPORTED_MODULE_7__/* .DEFAULT_NAV_MENU_ID */ .KB : _navMenuId, _toggleMenuOpen = props.toggleMenuOpen, toggleMenuOpen = _toggleMenuOpen === void 0 ? function() {} : _toggleMenuOpen;
    var trackEvent = (0,_helpers_observability__WEBPACK_IMPORTED_MODULE_3__/* .useObservability */ .C3)().trackEvent;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isExpanded = ref[0], setExpanded = ref[1];
    var ref1 = (0,_opendoor_auth_fe__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .aC)(), human = ref1.user, authentication = ref1.authentication;
    var isLoggedIn = authentication.state === "authenticated";
    var handleMenuClick = function() {
        // TODO: remove categoryOverride
        // observability is initialized with 'cosmos' as the category for all events
        trackEvent("cta-click", "menu", undefined, {
            categoryOverride: "homepage"
        });
        toggleMenuOpen();
    };
    var handleAccountClick = function() {
        // TODO: remove categoryOverride
        // observability is initialized with 'cosmos' as the category for all events
        trackEvent("cta-click", "account-icon", undefined, {
            categoryOverride: "homepage"
        });
        authentication.state === "authenticated" ? setExpanded(!isExpanded) : redirectToLogin();
    };
    var fullName = human === null || human === void 0 ? void 0 : human.fullName;
    var firstName = fullName ? fullName.split(" ")[0] : "";
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(SkipLink, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(Container, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(Left, {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(MenuButton, {
                                "aria-controls": navMenuId,
                                "aria-expanded": isMenuOpen ? "true" : "false",
                                "aria-haspopup": "true",
                                "aria-label": "Navigation menu",
                                id: navMenuButtonId,
                                onClick: handleMenuClick
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("img", {
                                src: "https://images.opendoor.com/source/s3/imgdrop-production/2024-09-1726263311004-74235.png?preset=square-2048",
                                alt: "Opendoor",
                                height: 27
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Middle, {
                        children: !hideHeaderNavLinks && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Nav, {
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(NavUL, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(NavLI, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(NavLink, {
                                            active: activeNav === "sell",
                                            href: "/",
                                            elementName: "homepage",
                                            children: "Sell"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(NavLI, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(NavLink, {
                                            active: activeNav === "buy",
                                            href: "/homes",
                                            elementName: "homes",
                                            children: "Buy"
                                        })
                                    }),
                                    (extraNavLinks || []).map(function(nav) {
                                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(NavLI, {
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(NavLink, {
                                                href: nav.href,
                                                children: nav.name
                                            })
                                        }, nav.name);
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Right, {
                        onClick: handleAccountClick,
                        children: isLoggedIn ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_opendoor_bricks_core_Box__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            cursor: "pointer",
                            fontWeight: "semibold",
                            children: [
                                "Welcome ",
                                firstName,
                                " \xa0",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(IconWrapper, {
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_EiChevronDownIcon__WEBPACK_IMPORTED_MODULE_6__/* .EiChevronDownIcon */ .O, {})
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_account_AccountMenu__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    isExpanded: isExpanded
                                })
                            ]
                        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            href: "#",
                            fontWeight: "semibold",
                            analyticsName: "cosmos-sign-in",
                            "aria-label": "",
                            children: "Sign In"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Header);


/***/ })

}]);